module.exports = __webpack_public_path__ + "static/media/admission smart.5139e8f1.svg";